export const TRX_ITEMS = [
  {
    name: '1Kbps',
    value: '1 kb/sec',
  },
  {
    name: '1Mbps (default)',
    value: '1 mb/sec',
  },
  {
    name: '100Mbps',
    value: '100 mb/sec',
  },
  {
    name: '500Mbps',
    value: '500 mb/sec',
  },
  {
    name: '1Gbps',
    value: '1 gb/sec',
  },
] as const;

export const DEFAULT_SORT_KEY = 'memory';
export const SORT_ITEMS = [
  {
    name: 'Target Name',
    value: 'name',
  },
  {
    name: 'CPU',
    value: 'cpu',
  },
  {
    name: 'Memory',
    value: 'memory',
  },
  {
    name: 'Disk',
    value: 'disk',
  },
  {
    name: 'RX',
    value: 'rx',
  },
  {
    name: 'TX',
    value: 'tx',
  },
];

export const DEFAULT_ORDER = 'asc';

export const MEMORY_STAT_ITEMS = [
  {
    name: 'Active Memory Usage (%) (Excluding Available Memory)',
    value: 'excludeAvailableMemory',
    description: '(Total - Available) / Total * 100',
  },
  {
    name: 'Active Memory Usage (%) (Excluding Free, Buffer, and Cached)',
    value: 'excludeFreeBufferCache',
    description: '(Total - Free - Buffer - Cached) / Total * 100',
  },
  {
    name: 'Physical Memory Usage (%)',
    value: 'physicalMemory',
    description: '(Total - Free) / Total * 100',
  },
] as const;

export const DEFAULT_MEMORY_STAT_VALUE = MEMORY_STAT_ITEMS[0].value;

export { DEFAULT_SERVER_COLOR_SET } from '@/common/components/molecules/serverNodeGraph/serverNodeGraph.define';

import { DEFAULT_SERVER_COLOR_SET } from '@/common/components/molecules/serverNodeGraph/serverNodeGraph.define';
import type { StatDataItem } from './types';

export const DEFAULT_STAT_ITEMS: StatDataItem[] = [
  { name: 'CPU', alias: '', color: DEFAULT_SERVER_COLOR_SET.cpu, field: 'cpu' },
  { name: 'Memory', alias: '', color: DEFAULT_SERVER_COLOR_SET.memory, field: 'memory' },
  { name: 'Disk', alias: '', color: DEFAULT_SERVER_COLOR_SET.disk, field: 'disk' },
  { name: 'RX', alias: '', color: DEFAULT_SERVER_COLOR_SET.rx, field: 'rx' },
  { name: 'TX', alias: '', color: DEFAULT_SERVER_COLOR_SET.tx, field: 'tx' },
];
